module.exports = __webpack_public_path__ + "static/img/twjd-sde8.a2f84ca.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sde8.png
// module id = 148
// module chunks = 0